import React from "react";
import { Col, Row, Spinner } from "react-bootstrap";

const LazyLoadingFormik = (props) => {
  return (
    <Row>
      <Col xs={12} className="text-center mt-5 mb-5">
        <Spinner
          animation="border"
          role="status"
          style={{ color: "var(--base-color)" }}
          {...props}
        />
      </Col>
    </Row>
  );
};

export default LazyLoadingFormik;
